<script>
import { mapState } from 'pinia';
import { orderStore } from '../../../stores/order';
import { Tools } from '../../../utils/tools';
import FormInput from '../form/form-input.vue';

export default {
	components: {
		FormInput
	},
	
	props: {
		field: Object
	},

	computed: {
		...mapState(orderStore, ['fieldsPersistentValues']),

		fieldType() {
			let type = 'text';
			if (this.field.isEmail === 'Y') type = 'email';
			if (this.field.isPhone === 'Y') type = 'tel';

			return type;
		},
		
		fieldMask() {
			let type = null;
			//if (this.field.isEmail === 'Y') type = 'email';
			if (this.field.isPhone === 'Y') type = 'tel';
			
			return type;
		},
		
		inputMode() {
			let type = null;
			if (this.field.isPhone === 'Y') type = 'text';

			return type;
		},
		
		fieldDataType() {
			let type = Tools.snakeToCamel(this.field.code);
			if (this.field.isEmail === 'Y') type = 'email';

			return type;
		},
		
		fieldClassList() {
			return {
				'checkout-item__field': this.field.isPhone !== 'Y' && this.field.isEmail !== 'Y'
			};
		}
	},
};
</script>

<template>
	<FormInput
		:id="'soa-property-' + field.id"
		:class-list="fieldClassList"
		:type="fieldType"
		:name="'ORDER_PROP_' + field.id"
		:placeholder="field.name"
		:required="field.required === 'Y'"
		:textarea="field.multiline === 'Y'"
		data-message="text"
		:look="true"
		:rule="fieldType"
		:mask="fieldMask"
		v-model:model-value="fieldsPersistentValues[field.id]"
		v-bind="$attrs"
		:input-mode="inputMode"
	>
	</FormInput>
</template>
